module.exports = __webpack_public_path__ + "static/img/企业文化6.8d06ff1e.png";